import { createStore } from 'vuex'
import api from '../api'

const token = localStorage.getItem('token')

export default createStore({
  state: {
    auth: {
      isAuthenticated: !!token,
      token: token,
      user: null
    }
  },
  mutations: {
    SET_AUTH(state, { token, user, refresh_token }) {
      state.auth.token = token
      state.auth.user = user
      state.auth.isAuthenticated = true
      if (token) {
        localStorage.setItem('token', token)
      }
      // Refresh-токен портала (30 дней) — для автоматического продления сессии
      if (refresh_token) {
        localStorage.setItem('refresh_token', refresh_token)
      }
    },
    CLEAR_AUTH(state) {
      state.auth.token = null
      state.auth.user = null
      state.auth.isAuthenticated = false
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
    },
    SET_USER(state, user) {
      state.auth.user = user
    }
  },
  actions: {
    async login({ commit }, { username, password, serialKey }) {
      const response = await api.login(username, password, serialKey)
      const data = response.data

      commit('SET_AUTH', {
        token: data.access_token,
        user: data.user
      })
      return { success: true }
    },
    async logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    async fetchCurrentUser({ commit, state }) {
      if (!state.auth.token) return
      
      try {
        const response = await api.getCurrentUser()
        commit('SET_AUTH', {
          token: state.auth.token,
          user: response.data
        })
      } catch (error) {
        commit('CLEAR_AUTH')
      }
    }
  },
  getters: {
    isAuthenticated: state => state.auth.isAuthenticated,
    user: state => state.auth.user,
    isAdmin: state => state.auth.user?.is_admin || false
  }
})

